import useLocalStorage from './useLocalStorage';

export const useSurveyDismissed = () => useLocalStorage('svce_survey_dismissed', false);
